import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Papa from 'papaparse';
import raw from './df.csv';
import { RingLoader } from "react-spinners";


const App = () => {
  const [data, setData] = useState([]);
  const [genere, setGenere] = useState('');
  const [uniqueGeneri, setUniqueGeneri] = useState([]);
  const [regista, setRegista] = useState('');
  const [uniqueRegisti, setUniqueRegisti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState("topN");
  const [filterValue, setFilterValue] = useState("");


  useEffect(() => {


    fetch(raw)
      .then(response => response.text())
      .then(csv => {
        Papa.parse(csv, {
          header: true,
          complete: (results) => {
            const rows = results.data;
            setData(rows);
            //const generi = [...new Set(results.data.map(item => item.Genere))];

            const generi = [...new Set(
              rows
                .filter(item => item.Tipo === "Genere")
                .map(item => item.Genere)
                .filter(Boolean)
            )];
            setUniqueGeneri(generi.sort());
            //const registi = [...new Set(results.data.map(item => item.Regista))];
             // Registi unici solo se Tipo === "Regista"
            const registi = [...new Set(
              rows
                .filter(item => item.Tipo === "Regista")
                .map(item => item.Regista)
                .filter(Boolean)
            )];
            setUniqueRegisti(registi.sort());
            setLoading(false);
          }
        });
      });
  }, []);

  

  const handleGenereChange = (event) => {
    setGenere(event.target.value);
  };

  const handleRegistaChange = (event) => {
    setRegista(event.target.value);
  };

  const filterData = () => {
    if (filterType === "topN") {
      return data
            .slice(0, parseInt(filterValue, 10) || 10);
    }
    if (filterType === "byGenere") {
      //const rows=data;
      return data
      .filter(item => (item.Genere === genere ))
      .sort((a, b) => a["Posizione"] - b["Posizione"]);





    }
    if (filterType === "byRegista") {
      return data
      .filter(item => (item.Regista === regista & item.Tipo === "Regista")
      );

    }
    return data;
  };

   return (
    <div className="container-fluid">
      <h1 className="text-center text-primary">I 500 migliori film della storia secondo Empire</h1>
      <p className="text-center text-secondary">Fonte: <a href="https://www.imdb.com/it/list/ls003073623/" target="_blank" rel="noopener noreferrer">Empire's 500 Greatest Movies of All Time</a></p>
      
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: "2rem" }}>
          <RingLoader
            color="grey"
            size={96}
            speedMultiplier={1.33} // simula animationDuration
          />
      </div>
      ) : (
      <div>
        <div>
        <div className='form-check'>
        <label className="form-check-label">
          <input className="form-check-input"
            type="radio"
            name="filter"
            value="topN"
            checked={filterType === "topN"}
            onChange={() => setFilterType("topN")}
          />
          Primi N film:
        </label>
        </div>
        <div className='form-check'>
        <label className="form-check-label">
          <input className="form-check-input"
            type="radio"
            name="filter"
            value="byGenere"
            checked={filterType === "byGenere"}
            onChange={() => setFilterType("byGenere")}
          />
          Selezionare genere:
        </label>
        </div>
        <div className='form-check'>
        <label className="form-check-label">
          <input className="form-check-input"
            type="radio"
            name="filter"
            value="byRegista"
            checked={filterType === "byRegista"}
            onChange={() => setFilterType("byRegista")}
          />
          Selezionare regista:
        </label>
        </div>
      </div>
      {filterType === "topN" && (
        <label className="input-group-text">
        <input 
          type="number"
          placeholder="Inserisci N"
          value={filterValue}
          onChange={(e) => setFilterValue(e.target.value)}
        />
        </label>
      )}
      {filterType === "byGenere" && (
        <label className="input-group-text">
        Selezionare ==>
        <select 
          value={genere} onChange={handleGenereChange}>
          
          {uniqueGeneri.map(prov => (
            <option key={prov} value={prov}>{prov}</option>
          ))}
        </select>
      </label>
      )}
      {filterType === "byRegista" && (
        <label className="input-group-text">
        Selezionare ==>
        <select
          value={regista} onChange={handleRegistaChange}>

          {uniqueRegisti.map(prov => (
            <option key={prov} value={prov}>{prov}</option>
          ))}
        </select>
      </label>
      )}
        <div>
      </div>
      <table className="table table-striped" >
        <thead>
          <tr>
            <th>Titolo</th>
            <th>Genere</th>
            <th>Regista</th>
            <th>Anno</th>
            <th>Posizione</th>
            <th>Punteggio IMDb</th>
            <th>URL</th>

          </tr>
        </thead>
        <tbody>
          {filterData().map((item, index) => (
            <tr key={index}>
              <td>{item.Titolo}</td>
              <td>{item.Genere}</td>
              <td>{item.Regista}</td>
              <td>{item.anno}</td>
              <td>{item.Posizione}</td>
              <td>{item.Punteggio_IMDb}</td>
              <td>
                  <a
                    href={item.URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Link scheda Film
                  </a>
              </td>

            </tr>
          ))}
        </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default App;
